import { render } from "./systemSet.vue?vue&type=template&id=50e2414c"
import script from "./systemSet.vue?vue&type=script&lang=js"
export * from "./systemSet.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__